<template>
  <div class="px-sm-4 px-md-12">
    <v-container>
      <v-row class="mb-4 mt-14">
        <v-col class="pt-0 form-top-back" cols="12">
          <v-btn @click="$router.push('/app/corpUsers')" color="blue" dark>
            <v-icon left> mdi-arrow-left </v-icon>
            Back
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" align-content="center" align="center">
        <v-col align-self="center">
          <v-card class="mb-3">
            <v-tabs
              :vertical="verticalTabs"
              :centered="!verticalTabs"
              :center-active="!verticalTabs"
            >
              <v-tab
                class="
                  d-flex
                  flex-column flex-md-row
                  justify-md-start justify-center
                "
              >
                <v-icon :left="verticalTabs">mdi-account-circle</v-icon>
                Profile
              </v-tab>

              <v-tab-item>
                <CorpUserOverview v-if="!loading" :selectedUser="isAddOrView" />
              </v-tab-item>
            </v-tabs>
          </v-card>
          <div class="d-flex justify-end" v-if="!isView">
            <v-btn
              :loading="isPerformingOperation"
              :disabled="isPerformingOperation"
              color="success"
              large
              @click="assignCorpUser"
              v-if="!isView"
              >Save</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import api from "../../../api";
import toasts from "../../../utils/toasts";
export default {
  data() {
    return {
      user: {},
      isEdit: false,
      isView: false,
      isAdd: false,
      isPerformingOperation: false,
      loading: false,
      newUser: {},
      verticalTabs: true,
      userId: null,
    };
  },
  computed: {
    isAddOrView() {
      return this.isAdd ? this.newUser : this.user;
    },
  },
  mounted() {
    this.isAdd = this.$route.path.includes("add");
    this.isEdit = this.$route.path.includes("edit");
    this.isView = this.$route.path.includes("details");

    if (this.isEdit || this.isView) {
      this.userId = this.$route.params.id;
      this.getCorpUserById();
    }

    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.verticalTabs = window.innerWidth >= 960;
      });
    });
    this.verticalTabs = window.innerWidth >= 960;
  },
  methods: {
    async assignCorpUser() {
      try {
        await api.corpUsers.assignCorpUser({
          request: this.newUser,
        });
        toasts.success("Assigned successfully");

        this.$router.push({ path: "/app/corpUsers" });
      } catch (error) {
        toasts.error(`could not assign user ${error}`);
      }
    },
    async getCorpUserById() {
      try {
        this.loading = true;
        this.user = await api.corpUsers.getById({
          id: this.userId,
        });
      } catch (error) {
        toasts.error(`Could not get corp user ${error}`);
        this.loading = false;
      }

      this.loading = false;
    },
  },
};
</script>

<style>
</style>